<template>
    <div class="statistics-table-wrap">
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div class="text-muted small">
                Menampilkan {{ rowFrom }}–{{ rowTo }} dari {{ formatNum(table.total_records) }} user
                <span v-if="totalPages > 1"> · halaman {{ table.serverParams.page }} / {{ totalPages }}</span>
            </div>
            <div class="text-muted small" v-if="table.serverParams.date">
                Data tanggal: <strong>{{ table.serverParams.date }}</strong>
            </div>
        </div>

        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
            :totalRows="table.total_records" :isLoading.sync="table.isLoading"
            :pagination-options="paginationOptions"
            :columns="table.columns" :rows="table.rows" styleClass="vgt-table bordered striped">

            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'username'">
                    <strong>{{ userField(props.row, 'username') }}</strong>
                </span>
                <span v-else-if="props.column.field == 'email'">
                    {{ userField(props.row, 'email') }}
                </span>
                <span v-else-if="props.column.field == 'phone'">
                    {{ userField(props.row, 'phone') || '—' }}
                </span>
                <span v-else-if="props.column.field == 'stat_package'">
                    <span class="stat-package-text">{{ displayPackage(props.row) }}</span>
                </span>
                <span v-else-if="props.column.field == 'stat_expired'">
                    <span v-if="!displayExpired(props.row)" class="text-muted">—</span>
                    <span v-else class="stat-expiry-cell">
                        <span class="badge badge-pill mb-1" :class="expiryClass(props.row)">
                            {{ expiryLabel(props.row) }}
                        </span>
                        <br>
                        <small class="text-muted">{{ formatTs(displayExpired(props.row)) }}</small>
                    </span>
                </span>
                <span v-else-if="props.column.field == 'message_sent'">
                    <span class="badge badge-success badge-stat">{{ formatNum(props.row.message_sent) }}</span>
                </span>
                <span v-else-if="props.column.field == 'message_pending'">
                    <span class="badge badge-warning text-dark badge-stat">{{ formatNum(props.row.message_pending) }}</span>
                </span>
                <span v-else-if="props.column.field == 'message_failed'">
                    <span class="badge badge-danger badge-stat">{{ formatNum(props.row.message_failed) }}</span>
                </span>
                <span v-else-if="props.column.field == 'incoming_message'">
                    <span class="badge badge-info badge-stat">{{ formatNum(props.row.incoming_message) }}</span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: ["date"],
        data() {
            return {
                packages: [],
                packageCache: {},
                table: {
                    total_records: 0,
                    isLoading: true,
                    columns: [{
                            label: "Username",
                            field: "username",
                            filterOptions: { enabled: true, placeholder: "Cari username" },
                            sortable: false,
                        },
                        {
                            label: "Email",
                            field: "email",
                            filterOptions: { enabled: true, placeholder: "Cari email" },
                            sortable: false,
                        },
                        {
                            label: "Telepon",
                            field: "phone",
                            filterOptions: { enabled: true, placeholder: "Cari telepon" },
                            sortable: false,
                        },
                        {
                            label: "Paket",
                            field: "stat_package",
                            filterOptions: { enabled: false },
                            sortable: false,
                            width: "140px",
                        },
                        {
                            label: "Masa Aktif",
                            field: "stat_expired",
                            filterOptions: { enabled: false },
                            sortable: false,
                            width: "150px",
                        },
                        {
                            label: "Sukses",
                            field: "message_sent",
                            filterOptions: { enabled: false },
                            sortable: false,
                            type: "number",
                        },
                        {
                            label: "Pending",
                            field: "message_pending",
                            filterOptions: { enabled: false },
                            sortable: false,
                            type: "number",
                        },
                        {
                            label: "Gagal",
                            field: "message_failed",
                            filterOptions: { enabled: false },
                            sortable: false,
                            type: "number",
                        },
                        {
                            label: "Masuk",
                            field: "incoming_message",
                            filterOptions: { enabled: false },
                            sortable: false,
                            type: "number",
                        },
                    ],
                    rows: [],
                    serverParams: {
                        columnFilters: {},
                        sort: [{ field: "", type: "" }],
                        date: moment().format("YYYY-MM-DD"),
                        page: 1,
                        limit: 10,
                    },
                },
            };
        },
        computed: {
            paginationOptions() {
                return {
                    enabled: true,
                    mode: "pages",
                    perPage: this.table.serverParams.limit,
                    dropdownAllowAll: false,
                    perPageDropdown: [10, 25, 50, 100, 200, 500],
                    nextLabel: "Berikutnya",
                    prevLabel: "Sebelumnya",
                    rowsPerPageLabel: "Baris per halaman",
                    ofLabel: "dari",
                    pageLabel: "halaman",
                };
            },
            totalPages() {
                if (!this.table.total_records || !this.table.serverParams.limit) return 1;
                return Math.ceil(this.table.total_records / this.table.serverParams.limit);
            },
            rowFrom() {
                if (!this.table.total_records) return 0;
                return (this.table.serverParams.page - 1) * this.table.serverParams.limit + 1;
            },
            rowTo() {
                const to = this.table.serverParams.page * this.table.serverParams.limit;
                return Math.min(to, this.table.total_records);
            },
        },
        watch: {
            date: {
                handler(v) {
                    this.table.serverParams.date = moment(v).format("YYYY-MM-DD");
                    this.table.serverParams.page = 1;
                    this.loadItems();
                },
                deep: true,
            },
        },
        async mounted() {
            this.fn = () => this.loadItems();
            this.$root.$on("refresh_table", this.fn);
            await this.loadPackages();
            this.loadItems();
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            formatNum(n) {
                return Number(n || 0).toLocaleString("id-ID");
            },
            async loadPackages() {
                try {
                    const res = await this.$store.dispatch("package_list");
                    const data = (res.data && res.data.data) ? res.data.data : (res.data || {});
                    this.packages = data.packages || [];
                } catch (e) {
                    this.packages = [];
                }
            },
            loadPackageName(packageId) {
                if (!packageId) return "";
                const pkg = this.packages.find((p) => Number(p.id) === Number(packageId));
                return pkg ? pkg.name : "";
            },
            userField(row, field) {
                return row.user && row.user[field] ? row.user[field] : "—";
            },
            pickPackageId(row) {
                if (row.stat_package_id) return row.stat_package_id;
                const up = row.user && row.user.user_package;
                return up ? up.package_id : null;
            },
            displayPackage(row) {
                if (row.stat_package) return row.stat_package;
                const up = row.user && row.user.user_package;
                if (up && up.package_data && up.package_data.name) return up.package_data.name;
                const fromList = this.loadPackageName(this.pickPackageId(row));
                if (fromList) return fromList;
                const pid = this.pickPackageId(row);
                return pid ? "Paket #" + pid : "—";
            },
            displayExpired(row) {
                const val = row.stat_expired
                    || (row.user && row.user.user_package && row.user.user_package.expired_at)
                    || row.expired_at
                    || null;
                return val ? Number(val) : null;
            },
            formatTs(ts) {
                return moment(Number(ts)).format("DD MMM YYYY HH:mm");
            },
            expiryLabel(row) {
                const ts = this.displayExpired(row);
                return ts && ts >= Date.now() ? "Aktif" : "Expired";
            },
            expiryClass(row) {
                const ts = this.displayExpired(row);
                if (!ts) return "badge-secondary";
                return ts >= Date.now() ? "badge-success" : "badge-danger";
            },
            normalizeStatRow(row) {
                const u = row.user || {};
                const up = u.user_package || {};
                const pd = up.package_data || {};
                const packageId = up.package_id || row.stat_package_id || null;
                const packageName = row.stat_package
                    || row.package_name
                    || pd.name
                    || this.loadPackageName(packageId)
                    || (packageId ? "Paket #" + packageId : "");
                const expiredAt = row.stat_expired || row.expired_at || up.expired_at || null;
                return Object.assign({}, row, {
                    stat_package: packageName,
                    stat_package_id: packageId,
                    stat_expired: expiredAt,
                });
            },
            async fetchUserPackage(user) {
                if (!user || !user.id || this.packageCache[user.id]) {
                    return this.packageCache[user.id] || null;
                }
                // Username filter is LIKE %value% — "cuan" can match wrong user; prefer email, then match by id.
                const filters = [];
                if (user.email) filters.push({ email: user.email });
                if (user.username) filters.push({ username: user.username });
                if (user.phone) filters.push({ phone: user.phone });

                for (const filter of filters) {
                    try {
                        const response = await this.$store.dispatch("admin_user_list", {
                            page: 1,
                            limit: 20,
                            owner: 0,
                            columnFilters: JSON.stringify(filter),
                        });
                        const body = response.data || {};
                        const payload = body.data || body;
                        const users = payload.users || [];
                        const matched = users.find((u) => Number(u.id) === Number(user.id));
                        if (matched && matched.user_package) {
                            this.$set(this.packageCache, user.id, matched.user_package);
                            return matched.user_package;
                        }
                    } catch (e) {
                        /* try next filter */
                    }
                }
                return null;
            },
            async enrichRows(rows) {
                const pending = [];
                const seen = new Set();
                rows.forEach((row) => {
                    const user = row.user;
                    if (!user || !user.id || seen.has(user.id)) return;
                    if (user.user_package && user.user_package.package_id) {
                        this.$set(this.packageCache, user.id, user.user_package);
                        seen.add(user.id);
                        return;
                    }
                    if (this.packageCache[user.id]) {
                        seen.add(user.id);
                        return;
                    }
                    seen.add(user.id);
                    pending.push(user);
                });
                const chunkSize = 15;
                for (let i = 0; i < pending.length; i += chunkSize) {
                    const chunk = pending.slice(i, i + chunkSize);
                    await Promise.all(chunk.map((user) => this.fetchUserPackage(user)));
                }
                return rows.map((row) => {
                    const user = row.user;
                    if (user && user.id && this.packageCache[user.id]) {
                        row = Object.assign({}, row, {
                            user: Object.assign({}, user, {
                                user_package: this.packageCache[user.id],
                            }),
                        });
                    }
                    return this.normalizeStatRow(row);
                });
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({}, this.table.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({ limit: params.currentPerPage, page: 1 });
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }],
                    page: 1,
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(Object.assign({}, params, { page: 1 }));
                this.loadItems();
            },
            async loadItems() {
                this.table.isLoading = true;
                this.$emit("loading", true);
                try {
                    const response = await this.getFromServer(this.table.serverParams);
                    const body = response.data || {};
                    const payload = body.data || body;
                    this.table.total_records = payload.total_records || 0;
                    this.table.rows = await this.enrichRows(payload.statistics || []);
                    this.$emit("summary", payload.summary || {});
                } catch (err) {
                    const msg = (err.response && err.response.data && err.response.data.message)
                        || "Gagal memuat statistik";
                    this.$toast.error(msg);
                }
                this.table.isLoading = false;
                this.$emit("loading", false);
            },
            async getFromServer(param) {
                const payload = {
                    page: param.page,
                    limit: param.limit,
                    date: param.date,
                };
                const filters = Object.assign({}, param.columnFilters || {});
                if (Object.keys(filters).length) {
                    payload.columnFilters = JSON.stringify(filters);
                }
                return await this.$store.dispatch("statistics_list", payload);
            },
        },
    };
</script>

<style scoped>
.statistics-table-wrap :deep(.vgt-wrap) {
    border-radius: 8px;
    overflow: hidden;
}
.badge-stat {
    font-size: 13px;
    font-weight: 600;
    min-width: 42px;
    padding: 6px 10px;
}
.stat-package-text {
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    color: #333;
    line-height: 1.35;
    max-width: 140px;
    white-space: normal;
}
.stat-expiry-cell {
    display: inline-block;
    line-height: 1.35;
}
</style>
